import React, { Component } from 'react';

import IdentityGeneral from './IdentityGeneral';
import MobilityGeneral from './MobilityGeneral';
import IssuesGeneral from './IssuesGeneral';

import LeafletMapGeneral from '../b-LeafletMap/LeafletMapGeneral';

class KeyFigures extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      territory: props.territory
    };
  }

  render() {
    return(
      <div className="row">
        <div className="col">
          <div className="row">
            <div className="col-6">
              <IdentityGeneral territory={this.state.territory}/>
              {this.state.territory.all_travels != null && <MobilityGeneral territory={this.state.territory}/>}
            </div>
            <div className="col-6 d-flex flex-column">
              <div className="row h-100">
                <div className="col">
                    <LeafletMapGeneral id="main_map" communes={this.props.territory.communes}/>
                </div>
              </div>
              {this.state.territory.issues != null && <IssuesGeneral territory={this.state.territory}/>}

            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12">
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default KeyFigures;
